import { apiFetchWeb } from "@/hooks/apiFetchWeb"

type LoginData = {
  email: string
  password: string
}

type RegisterData = {
  name: string
  email: string
  password: string
}

export type ChangePasswordData = {
  current_password: string
  new_password: string
  new_password_confirmation: string
}

type RegisterResponse = {
  customer: {
    id: number
    name: string
    email: string
  }
}

type LoginResponse = {
  customer: {
    id: number
    name: string
    email: string
  }
  token: string
}

export type ResetPasswordData = {
  email: string
  token: string
  password: string
  password_confirmation: string
}

export const websiteAuthService = {
  resendVerification: async (email: string) =>
    apiFetchWeb<{ message: string }>("website/customer/verification-email", {
      method: "POST",
      body: JSON.stringify({ email }),
    }),
  verifyEmail: async (verificationPath: string, signal?: AbortSignal) => {
    if (
      !/^\/api\/website\/customer\/verify-email\/\d+\/[a-f0-9]{40}\?/.test(
        verificationPath
      )
    ) {
      throw new Error(
        "This verification link is invalid. Please request a new link."
      )
    }
    return apiFetchWeb<{ message: string }>(verificationPath.slice(5), {
      signal,
    })
  },
  forgotPassword: async (email: string) =>
    apiFetchWeb<{ message: string }>("website/customer/forgot-password", {
      method: "POST",
      body: JSON.stringify({ email }),
    }),
  resetPassword: async (data: ResetPasswordData) =>
    apiFetchWeb("website/customer/reset-password", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  register: async (data: RegisterData) =>
    apiFetchWeb<RegisterResponse>("website/customer/register", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  login: async (data: LoginData) =>
    apiFetchWeb<LoginResponse>("website/customer/login", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  logout: async () =>
    apiFetchWeb("website/customer/logout", {
      method: "POST",
    }),
  profile: async () =>
    apiFetchWeb("website/customer/profile", {
      method: "POST",
    }),
  changePassword: async (data: ChangePasswordData) =>
    apiFetchWeb("website/customer/change-password", {
      method: "PUT",
      body: JSON.stringify(data),
    }),
}
